const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/pro-light-svg-icons/faCircleNotch");